"use client";

import Link from "next/link";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/firebase/auth";

export default function HomePage() {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) router.replace("/dashboard");
  }, [user, loading, router]);

  return (
    <main className="min-h-screen bg-gradient-to-br from-brand-50 to-white">
      <header className="border-b bg-white">
        <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between">
          <div>
            <div className="text-xs text-brand-700">มหาวิทยาลัยมหาสารคาม</div>
            <div className="text-lg font-semibold text-brand-700">ระบบทวนสอบ</div>
          </div>
          <Link href="/login" className="rounded-md bg-brand-500 text-white px-4 py-2 hover:bg-brand-600 text-sm">
            เข้าสู่ระบบ
          </Link>
        </div>
      </header>

      <section className="mx-auto max-w-5xl px-6 py-16">
        <h1 className="text-4xl font-bold text-brand-700 leading-tight">
          ระบบสารสนเทศการทวนสอบรายวิชาระดับหลักสูตร
        </h1>
        <p className="mt-4 text-lg text-slate-700 max-w-3xl">
          สอดคล้องกับมาตรฐานการอุดมศึกษา พ.ศ. 2565 และ AUN-QA v4.0 Criterion 4
          ช่วยลดภาระอาจารย์และผู้ทรงคุณวุฒิ ผ่านการวิเคราะห์ด้วย AI
        </p>

        <div className="mt-8 flex gap-3">
          <Link href="/login" className="rounded-md bg-brand-500 text-white px-6 py-3 hover:bg-brand-600">
            เริ่มใช้งาน →
          </Link>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <Feature title="สำหรับอาจารย์" desc="สร้าง มคอ.3 / มคอ.5 อัตโนมัติ พร้อม Constructive Alignment check" />
          <Feature title="สำหรับประธานหลักสูตร" desc="Dashboard ติดตามการทวนสอบทุกรายวิชาในหลักสูตร" />
          <Feature title="สำหรับผู้ทรงคุณวุฒิ" desc="AI วิเคราะห์เอกสารล่วงหน้า กรรมการแค่ tick เห็นด้วยหรือ comment" />
        </div>
      </section>

      <footer className="border-t bg-white">
        <div className="mx-auto max-w-7xl px-6 py-6 text-sm text-slate-600">
          © 2568 มหาวิทยาลัยมหาสารคาม · Pilot — Path B MVP
        </div>
      </footer>
    </main>
  );
}

function Feature({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="rounded-xl border bg-white p-6 shadow-sm">
      <h3 className="font-semibold text-brand-700">{title}</h3>
      <p className="mt-2 text-sm text-slate-600">{desc}</p>
    </div>
  );
}
